import { SpinResponse, ErrorLevel } from '@cgs/data-access';
import { ResponseHolder } from '../../../../reels_engine/state_machine/response_holder';
import { BaseGameRule } from '../../../../reels_engine/state_machine/rules/infra/base_game_rule';
import { BaseGameState } from '../../../../reels_engine/state_machine/states/base_game_state';

export class SpecConditionStopToRegularSpin<
  TResponse extends SpinResponse,
> extends BaseGameRule<TResponse> {
  private readonly _groupNames: string[] | null;

  constructor(
    sourceState: BaseGameState<TResponse>,
    responseHolder: ResponseHolder<TResponse>,
    groupNames: string[] | null = null
  ) {
    super(sourceState, responseHolder);
    this._groupNames = groupNames;
  }

  ruleCondition(resp: ResponseHolder<TResponse>): boolean {
    return (
      !resp.curResponse.isBonus &&
      !resp.curResponse.isScatter &&
      !!this._groupNames &&
      !!this.responseHolder.curResponse.specialSymbolGroups?.some((g) =>
        this._groupNames!.includes(g.type as string)
      ) &&
      !resp.curResponse.freeSpinsInfo &&
      resp.curResponse.errorLevel != ErrorLevel.Critical
    );
  }
}
